import React from 'react';
import './OrgTypeDialog.css';

const OrgTypeDialog = ({ onSelect }) => {
  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <h2>Organization Type</h2>
        <p className="dialog-question">
          What type of organization are you creating?
        </p>
        <div className="dialog-buttons">
          <button
            className="dialog-button university-button"
            onClick={() => onSelect('university')}
          >
            <span className="button-icon">🏛️</span>
            <span className="button-text">
              <strong>University/College</strong>
              <small>Full institution access</small>
            </span>
          </button>
          <button
            className="dialog-button org-button"
            onClick={() => onSelect('on_campus_org')}
          >
            <span className="button-icon">🏢</span>
            <span className="button-text">
              <strong>On-Campus Organization</strong>
              <small>Subset of a university (requires existing university account)</small>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrgTypeDialog;
